import React from 'react';
import { PromptConfirmation } from 'ui';
import { PromptProps, withPrompt } from 'app/components';
import { UserMembersTranslation } from '../constants';
import { RouterProps } from 'app/components/enhancers/with-router';

interface UserMembersPromptProps {
  router: RouterProps;
  shouldPrompt: boolean;
  translation: UserMembersTranslation;
}

const UserMembersPromptComponent: React.FC<UserMembersPromptProps & PromptProps> = ({
  shouldDisplayModal, translation, continue: onContinue, cancel
}) => {
  return shouldDisplayModal
    ? <PromptConfirmation
      title={translation.cancel_changes}
      description={translation.are_you_sure}
      continueText={translation.undo_all}
      cancelText={translation.go_back}
      onContinue={onContinue}
      onCancel={cancel} />
    : null;
};

export const UserMembersPrompt = withPrompt(UserMembersPromptComponent);
